export const CalendarBlank = ({ className }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2532_68160)">
        <path
          d="M65 12.5H15C13.6193 12.5 12.5 13.6193 12.5 15V65C12.5 66.3807 13.6193 67.5 15 67.5H65C66.3807 67.5 67.5 66.3807 67.5 65V15C67.5 13.6193 66.3807 12.5 65 12.5Z"
          stroke={!className && '#A5A5A5'}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55 7.5V17.5"
          stroke={!className && '#A5A5A5'}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 7.5V17.5"
          stroke={!className && '#A5A5A5'}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 27.5H67.5"
          stroke={!className && '#A5A5A5'}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2532_68160">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
